import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

const attributesObjRef = {
  valid_nomenclature: {
    serverSide: true,
    values: [
      { id: '1', name: 'Oui' },
      { id: '0', name: 'Non' },
    ],
  },
  temperature_meter: {
    serverSide: true,
    values: [
      { id: '1', name: 'Oui' },
      { id: '0', name: 'Non' },
    ],
  },
  meter_property_name: {
    serverSide: true,
    type: '$null',
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
};
const attributesObj = {
  valid_nomenclature: {
    serverSide: true,
    values: ['1'],
  },
  temperature_meter: {
    serverSide: true,
    values: ['1'],
  },
  meter_property_name: {
    serverSide: true,
    type: '$null',
    values: ['O'],
  },
};

export default (store) => {
  store.registerModule(
    ['sensors', 'errors'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({}),
        treatListResponse: treatsItems({
          datetimeFieldNames: ['error_datetime'],
        }),
      }),
      attributesObj,
      attributesObjRef,
      makeQueryParams: makeListRequest({}),
      makeHttpParamsUrl: (id) =>
        `${process.env.MYPREDITY_BASE_URI}/properties/${id}/sensors_errors`,
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'sensors/errors',
    store,
  });
  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});

  basePlugin.onInit(() => {
    store.commit('sensors/errors/SET_ITEMS_PAGE_SIZE', 1);

    store.subscribeAction((action) => {
      if (action.type === 'sensors/properties/addCurrent') {
        store.dispatch('sensors/errors/setUrlParamId', action.payload.id);
      }
    });
  });
};
